/** Component page that takes the feedback from the user on this particular stage and stores it away.  
 * If they approve it can also trigger a stage increment.
 */
import React from 'react';
import { FormControl, Form, Button } from 'react-bootstrap';
import StageManager from '../../services/stageManager';
import PageHoc from '../../HoC/PageHoC';
import { sendFeedback } from '../../services/feedbackManager';
import Loader from '../loader';
import { setStage } from '../../action/userActions';

class AcceptRejectStage extends React.Component {
    constructor() {
        super();
        this.stageMan = new StageManager();
        this.state = {
            feedback: "",
            loading: false
        }
    }
    componentWillMount() {
        if (this.props.location.state.type === 'accepted') {
            this.setState({ type: "accepted" });
        } else {
            this.setState({ type: "declined" });
        }
        this.setState({
            stageObj: this.stageMan.getStageByIndex(this.props.location.state.stage),
            stage: this.props.location.state.stage
        }, () => {
            this.setState({ descText: this.state.stageObj[this.props.location.state.type].desc })
        })
    }
    setFeedback = (ev, input) => this.setState({ feedback: ev.target.value });

    onButtonSubmit = () => {
        const { stageObj, stage, feedback, type } = this.state;
        const object = {
            feedbackName: stageObj.name,
            stage: stage,
            feedbackValue: feedback,
            type: type
        }
        this.loading();
        sendFeedback(object).then((res) => {
            if (type === "accepted") {
                setStage(stage + 1);
                this.props.addNotification({ status: "success", message: "Thank you for leaving feedback" });
            } else {
                this.props.addNotification({ status: "success", message: "Thank you for leaving feedback" });
            }
            this.loading();
        }).catch((e) => {
            this.loading();
            this.props.addNotification({ status: "fail", message: e.response.data });
        })
    }
    loading = () => this.setState((prevState) => ({ loading: !prevState.loading }));
    render() {
        const { descText, loading } = this.state;
        // let stageObj = this.stageMan.getStageByIndex(this.props.location.state.stage);
        // let descText = stageObj[this.props.location.state.type].desc;
        if (loading) {
            return <Loader />
        }
        return (
            <div className={"pageContainer"}>
                <h2>Stage Feedback</h2>
                <p>{descText}</p>
                <Form>
                    <FormControl as="textarea" size={"lg"} onChange={this.setFeedback} placeholder="Feedback"></FormControl>
                    <br />
                    <Button onClick={this.onButtonSubmit}>{this.state.type === "accepted" ? 'Accept' : 'Reject'}</Button><span>&nbsp;</span>
                    <Button onClick={this.props.history.goBack}>Cancel</Button>
                </Form>
            </div>
        );
    }
}

export default PageHoc(AcceptRejectStage);


// WEBPACK FOOTER //
// ./src/components/Pages/AcceptRejectStage.js